import Axios from 'axios';
import * as TokenHelpers from '../utils/tokenHelpers';
import * as ApiHelper from '../utils/apiHelper';

export function checkOrder(data) {
  let path = ApiHelper.API_ROOT+'/customers/orders';
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: path,
      method: 'patch',
      data: data,
      headers: headers
    })
    .then(function(response) {
      console.log("order check response", response.data);
      resolve(response.data)
    })
    // .catch(ApiHelper.handleUserAuth) //now allow non logged in user to add cart
    .catch(function(error) {
      console.log("order check error", error.response.data);
      reject({error: error.response.data})
    });
  });
}

export function createOrder(data) {

  let path = ApiHelper.API_ROOT+'/customers/orders/dtla/payment-intent';
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: path,
      method: 'POST',
      data: data,
      headers: headers
    })
    .then(function(response) {
      resolve(response.data)
    }).catch(ApiHelper.handleUserAuth).catch(function(error) {
      console.log(error,"response error")
      reject({error: error.response.data})
    });
  });
}

export function fetchOrders(data) {

  let path = ApiHelper.API_ROOT+'/customers/orders';
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: path,
      method: 'get',
      headers: headers
    })
    .then(function(response) {
      console.log("orders get success", response.data);
      resolve(response.data)
    }).catch(ApiHelper.handleUserAuth).catch(function(error) {
      console.log("orders get error", error.response.data);
      reject({error: error.response.data})
    });
  });
}

export function getOrder(id) {

  return new Promise((resolve, reject) => {
    Axios({
      url: `${ApiHelper.API_ROOT}/customers/orders?id=${id}`,
      method: 'get',
      headers: ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve())
    })
    .then(function(response) {
      console.log("order get success", response.data);
      resolve(response.data)
    }).catch(ApiHelper.handleUserAuth).catch(function(error) {
      console.log("order get error", error.response.data);
      reject({error: error.response.data})
    });
  });
}

export function updatePaymentMethodForOrder(data) {

  let path = ApiHelper.API_ROOT+`/customers/orders/dtla/payment-intent/${data.id}`;
  return new Promise((resolve, reject) => {
    let headers = ApiHelper.getRequestHeaders(true, TokenHelpers.retrieve());
    Axios({
      url: path,
      method: 'POST',
      data: {
        paymentMethodId: data.paymentMethodId,
      },
      headers: headers
    })
    .then(function(response) {
      resolve(response.data)
    }).catch(ApiHelper.handleUserAuth).catch(function(error) {
      reject({error: error.response.data})
    });
  });
}



// WEBPACK FOOTER //
// ./src/services/orders.js